var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.345,
    height: 27.032,
    viewBox: "0 0 26.345 27.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.06 0.12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.261 0.085)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.795 18.206)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.73 1.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.906,75.886h-.613a.293.293,0,1,1,0-.586h.613a.293.293,0,1,1,0,.586Z",
    transform: "translate(-37 -75.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.73 3.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.906,80.886h-.613a.293.293,0,0,1,0-.586h.613a.293.293,0,0,1,0,.586Z",
    transform: "translate(-37 -80.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.73 4.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.906,85.886h-.613a.293.293,0,0,1,0-.586h.613a.293.293,0,0,1,0,.586Z",
    transform: "translate(-37 -85.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.406,80.886h-.613a.293.293,0,0,1,0-.586h.613a.293.293,0,0,1,0,.586Z",
    transform: "translate(-15.5 -80.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.406,85.886h-.613a.293.293,0,0,1,0-.586h.613a.293.293,0,0,1,0,.586Z",
    transform: "translate(-15.5 -85.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.504 5.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.693,91.1a.3.3,0,0,1-.293-.293v-.613a.293.293,0,1,1,.586,0v.613A.3.3,0,0,1,32.693,91.1Z",
    transform: "translate(-32.4 -89.9)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.171 5.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.693,91.1a.3.3,0,0,1-.293-.293v-.613a.293.293,0,1,1,.586,0v.613A.3.3,0,0,1,27.693,91.1Z",
    transform: "translate(-27.4 -89.9)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.839 5.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.693,91.1a.3.3,0,0,1-.293-.293v-.613a.293.293,0,1,1,.586,0v.613A.3.3,0,0,1,22.693,91.1Z",
    transform: "translate(-22.4 -89.9)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.693,69.6a.3.3,0,0,1-.293-.293v-.613a.293.293,0,1,1,.586,0v.613A.3.3,0,0,1,32.693,69.6Z",
    transform: "translate(-32.4 -68.4)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.693,69.6a.3.3,0,0,1-.293-.293v-.613a.293.293,0,1,1,.586,0v.613A.3.3,0,0,1,27.693,69.6Z",
    transform: "translate(-27.4 -68.4)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.786 1.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.158,78.551H22.493a.3.3,0,0,1-.293-.293v-1.6a.3.3,0,0,1,.293-.293.773.773,0,0,0,.773-.773.3.3,0,0,1,.293-.293h1.6a.3.3,0,0,1,.293.293v2.665A.266.266,0,0,1,25.158,78.551Zm-2.345-.613h2.052V75.886H23.852a1.42,1.42,0,0,1-1.039,1.039Z",
    transform: "translate(-22.2 -75.3)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.805 10.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.593,46.249a.3.3,0,0,1-.293-.293V39.293a.293.293,0,1,1,.586,0v6.662A.3.3,0,0,1,34.593,46.249Z",
    transform: "translate(-34.3 -39)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.1 6.826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.693,36.493A.3.3,0,0,1,20.4,36.2V25.993a.293.293,0,0,1,.586,0V36.2A.3.3,0,0,1,20.693,36.493Z",
    transform: "translate(-20.4 -25.7)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.449,73.667H1.564a.289.289,0,0,1-.24-.107.272.272,0,0,1-.053-.24l1.652-8.5a.894.894,0,0,1,.906-.72h9.354a.913.913,0,0,1,.879.72l1.679,8.528a.256.256,0,0,1-.053.24A.326.326,0,0,1,15.449,73.667ZM1.937,73.081H15.1l-1.6-8.155a.32.32,0,0,0-.32-.24H3.83a.344.344,0,0,0-.32.24Z",
    transform: "translate(-1.261 -64.1)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.967)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.92,11.413a.312.312,0,0,1-.293-.24,4.186,4.186,0,0,0-1.119-2.079,4.077,4.077,0,0,0-2.079-1.119.3.3,0,1,1,.107-.586,4.818,4.818,0,0,1,2.372,1.279,4.707,4.707,0,0,1,1.279,2.372.3.3,0,0,1-.24.346C79.946,11.413,79.946,11.413,79.92,11.413Z",
    transform: "translate(-76.185 -7.385)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.479,5.845a.312.312,0,0,1-.293-.24,6.439,6.439,0,0,0-1.759-3.2,6.2,6.2,0,0,0-3.2-1.732.3.3,0,0,1-.24-.346.3.3,0,0,1,.346-.24,7.137,7.137,0,0,1,5.41,5.41.3.3,0,0,1-.24.346Z",
    transform: "translate(-76.985 -0.085)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08 3.917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.168,16.761a.312.312,0,0,1-.293-.24,1.463,1.463,0,0,0-1.146-1.146.3.3,0,0,1,.107-.586,2.084,2.084,0,0,1,1.039.56,1.994,1.994,0,0,1,.56,1.039.3.3,0,0,1-.24.346C78.221,16.761,78.194,16.761,78.168,16.761Z",
    transform: "translate(-76.485 -14.785)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.764 10.438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.019 0.027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.061,45.682a.293.293,0,0,1-.266-.16l-.959-1.679a2.9,2.9,0,0,1,.4-3.3l.8-1.066a.3.3,0,1,1,.48.373l-.8,1.066a2.412,2.412,0,0,0-.346,2.665l.959,1.679a.3.3,0,0,1-.107.4A.942.942,0,0,0,62.061,45.682Z",
    transform: "translate(-60.485 -39.353)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.745,45.635a.2.2,0,0,1-.133-.027.3.3,0,0,1-.107-.4l.959-1.732a2.412,2.412,0,0,0-.346-2.665l-.8-1.066a.3.3,0,0,1,.48-.373l.8,1.066a2.91,2.91,0,0,1,.4,3.3l-.959,1.732A.368.368,0,0,1,76.745,45.635Z",
    transform: "translate(-76.253 -39.253)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.049,46.863a.293.293,0,0,1-.266-.16,2.86,2.86,0,0,1,.4-3.331.3.3,0,1,1,.48.373,2.365,2.365,0,0,0-.346,2.665.3.3,0,0,1-.107.4A.379.379,0,0,1,61.049,46.863Z",
    transform: "translate(-60.413 -43.253)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.638 8.665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.493,38.649a.3.3,0,0,1-.293-.293V32.893a.293.293,0,1,1,.586,0v5.463A.3.3,0,0,1,71.493,38.649Z",
    transform: "translate(-71.2 -32.6)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.1 3.335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.211,20.222a3.844,3.844,0,0,1-2.265-.746.3.3,0,1,1,.373-.48,3.315,3.315,0,0,0,1.919.64,3.213,3.213,0,0,0,2.985-2,.339.339,0,0,1,.24-.187l5.17-.48a.334.334,0,0,1,.293.16,1.466,1.466,0,1,0,0-1.439.306.306,0,0,1-.293.16l-5.2-.48a.256.256,0,0,1-.24-.187,3.254,3.254,0,0,0-2.985-2,3.219,3.219,0,0,0-3.225,3.225.293.293,0,1,1-.586,0,3.822,3.822,0,0,1,7.275-1.626l4.85.453a2.083,2.083,0,0,1,1.679-.879,2.052,2.052,0,0,1,0,4.1,2.014,2.014,0,0,1-1.679-.879l-4.85.453A3.832,3.832,0,0,1,24.211,20.222Z",
    transform: "translate(-20.4 -12.6)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.312 5.547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,24.1a1.6,1.6,0,1,1,1.6-1.6A1.57,1.57,0,0,1,30.3,24.1Zm0-2.638a1.013,1.013,0,1,0,1.013,1.013A1.012,1.012,0,0,0,30.3,21.46Z",
    transform: "translate(-28.7 -20.9)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotion);
export default __webpack_public_path__ + "static/media/motion.3eeb2435.svg";
export { ForwardRef as ReactComponent };